// extracted by mini-css-extract-plugin
export default {"container":"_tQ2izcbJzpiF3sDrAv3","label":"xoWahuOQjGnydLKn3inw","description":"nD5n42NwQv2uKAtahTH_","link":"MNZQ2hj9dJOWRZVidNCn","pulse":"PCCWAvyj43E46lHxkhCx"};